import { useState, FormEvent } from 'react';
import type { UserSettings } from '../../types';

interface SetupFormProps {
  onSubmit: (settings: UserSettings) => void;
  isLoading: boolean;
}

export default function SetupForm({ onSubmit, isLoading }: SetupFormProps) {
  const [weight, setWeight] = useState<string>('80');
  const [gender, setGender] = useState<'male' | 'female'>('male');
  const [targetBac, setTargetBac] = useState<string>('0.5');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    const weightNum = parseFloat(weight);
    const targetBacNum = parseFloat(targetBac);

    if (isNaN(weightNum) || weightNum < 30 || weightNum > 300) {
      return;
    }

    if (isNaN(targetBacNum) || targetBacNum < 0 || targetBacNum > 3) {
      return;
    }

    onSubmit({
      weight: weightNum,
      gender,
      targetBac: targetBacNum
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Weight */}
      <div>
        <label htmlFor="weight" className="block text-sm font-medium text-gray-300 mb-2">
          Váha (kg)
        </label>
        <input
          id="weight"
          type="number"
          value={weight}
          onChange={(e) => setWeight(e.target.value)}
          min="30"
          max="300"
          step="1"
          className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-lg focus:ring-2 focus:ring-beer focus:border-transparent"
          required
        />
      </div>

      {/* Gender */}
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Pohlaví
        </label>
        <div className="grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={() => setGender('male')}
            className={`py-3 px-4 rounded-lg font-medium transition-colors ${
              gender === 'male'
                ? 'bg-beer text-gray-900'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            }`}
          >
            Muž
          </button>
          <button
            type="button"
            onClick={() => setGender('female')}
            className={`py-3 px-4 rounded-lg font-medium transition-colors ${
              gender === 'female'
                ? 'bg-beer text-gray-900'
                : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
            }`}
          >
            Žena
          </button>
        </div>
      </div>

      {/* Target BAC */}
      <div>
        <label htmlFor="targetBac" className="block text-sm font-medium text-gray-300 mb-2">
          Cílové promile
        </label>
        <input
          id="targetBac"
          type="number"
          value={targetBac}
          onChange={(e) => setTargetBac(e.target.value)}
          min="0"
          max="3"
          step="0.1"
          className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white text-lg focus:ring-2 focus:ring-beer focus:border-transparent"
          required
        />
        <p className="mt-2 text-sm text-gray-400">
          Doporučeno: 0.3 - 0.8 ‰ pro mírnou opilost
        </p>
      </div>

      {/* Submit */}
      <button
        type="submit"
        disabled={isLoading}
        className="w-full py-4 bg-beer hover:bg-beer-dark text-gray-900 font-bold text-lg rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isLoading ? 'Spouštím...' : 'Spustit sledování'}
      </button>
    </form>
  );
}
